const TextArea = ({ placeholder, name }) => {
  return (
    <textarea
      name={name}
      placeholder={placeholder}
      rows="10"
      required
      className="relative w-full border border-olive placeholder:text-olive placeholder:opacity-50 outline-none text-body2Mobile md:text-body2Desktop text-olive font-chivoMono px-[13px] py-[15px] lg:p-smallDesktop"
    />
  )
}

export default TextArea
